import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../../services/api';

interface ReviewStatEntry {
  idealResourcesRemaining: number;
  actualResourcesRemaining: number;
  idealBurnRate: number;
  actualBurnRate: number;
}

export interface ReviewStatistics {
  begin: number;
  end: number;
  lastRecordedDate: number;
  statistics: Record<string, ReviewStatEntry>;
}

export function useReviewStatistics(projectId: string, options?: { enabled?: boolean }) {
  return useQuery<ReviewStatistics>({
    queryKey: ['review', projectId],
    queryFn: () => api.get<ReviewStatistics>(`/review/${projectId}`),
    enabled: options?.enabled !== false && !!projectId,
  });
}

export function useSetReviewDateRange(projectId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ begin, end }: { begin: Date; end: Date }) => {
      const fmt = (d: Date) => d.toISOString().slice(0, 19) + '+00:00';
      return api.put<void>(`/project/${projectId}/review/begin/${fmt(begin)}/end/${fmt(end)}`, {});
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['review', projectId] });
    },
  });
}
